import { useAtomValue, useSetAtom } from "jotai";
import { useCallback } from "react";
import {
  promoProductsListAtom,
  promoProductsIsLoadingAtom,
  promoProductsIsRefreshingAtom,
  promoProductsErrorAtom,
  promotionProductsFilterInfoAtom,
  promotionProductsColumnsAtom,
  promotionProductsCurrentPageAtom,
  promotionProductsPageLimitAtom,
  promoProductsTotalCount,
  promoProductsIsAllProductsInScopeAtom,
} from "@/store/promotion/promotionProducts.atoms";
import {
  getPromoProductsByPromoEventIdAtom,
  setPromotionProductsFilterAtom,
  setPromotionProductsCurrentPageAtom,
} from "@/store/promotion/promotionProducts.actions";

interface GetPromoProductsParams {
  promoEventId: number;
  isLoading?: boolean;
  isRefreshing?: boolean;
}

export function usePromotionProduct() {
  const promoProducts = useAtomValue(promoProductsListAtom);
  const isLoading = useAtomValue(promoProductsIsLoadingAtom);
  const isRefreshing = useAtomValue(promoProductsIsRefreshingAtom);
  const error = useAtomValue(promoProductsErrorAtom);
  const filterInfo = useAtomValue(promotionProductsFilterInfoAtom);
  const columns = useAtomValue(promotionProductsColumnsAtom);
  const currentPage = useAtomValue(promotionProductsCurrentPageAtom);
  const pageLimit = useAtomValue(promotionProductsPageLimitAtom);
  const totalCount = useAtomValue(promoProductsTotalCount);
  const isAllProductsInScope = useAtomValue(promoProductsIsAllProductsInScopeAtom);
  const getPromoProductsAction = useSetAtom(getPromoProductsByPromoEventIdAtom);
  const setFilter = useSetAtom(setPromotionProductsFilterAtom);
  const setCurrentPage = useSetAtom(setPromotionProductsCurrentPageAtom);

  const getPromoProductsByPromoEventId = useCallback(
    (params: GetPromoProductsParams) => {
      return getPromoProductsAction({ ...params });
    },
    [getPromoProductsAction]
  );

  return {
    promoProducts,
    isLoading,
    isRefreshing,
    error,
    filterInfo,
    columns,
    currentPage,
    pageLimit,
    totalCount,
    isAllProductsInScope,
    setFilter,
    setCurrentPage,
    getPromoProductsByPromoEventId,
  };
}

export type { GetPromoProductsParams };
